import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cguService from '../services/cguService';
import { CGU_CONFIG, isVersionOutdated } from '../config/cguConfig';

export const useCGUStatus = () => {
  const { t } = useTranslation();
  const [cguStatus, setCguStatus] = useState({
    accepted: false,
    acceptedAt: null,
    version: CGU_CONFIG.CURRENT_VERSION,
    loading: true,
    error: null
  });

  // Charger le statut CGU au montage du composant
  useEffect(() => {
    loadCGUStatus();
  }, []);

  const loadCGUStatus = async () => {
    try {
      setCguStatus(prev => ({ ...prev, loading: true, error: null }));
      const status = await cguService.checkCGUStatus();
      
      // Vérifier si la version acceptée est à jour
      const needsUpdate = isVersionOutdated(status.version, CGU_CONFIG.CURRENT_VERSION);
      
      setCguStatus({
        accepted: status.accepted && !needsUpdate, // Faux si version obsolète
        acceptedAt: status.acceptedAt,
        version: status.version,
        needsUpdate: needsUpdate,
        currentVersion: CGU_CONFIG.CURRENT_VERSION,
        loading: false,
        error: null
      });
    } catch (error) {
      console.error('Erreur chargement statut CGU:', error);
      setCguStatus(prev => ({
        ...prev,
        loading: false,
        error: t('cgu.errors.loadingError')
      }));
    }
  };

  const acceptCGU = async (version = CGU_CONFIG.CURRENT_VERSION) => {
    try {
      const result = await cguService.acceptCGU(version);
      setCguStatus({
        accepted: true,
        acceptedAt: new Date().toISOString(),
        version: version,
        needsUpdate: false,
        currentVersion: CGU_CONFIG.CURRENT_VERSION,
        loading: false,
        error: null
      });
      return result;
    } catch (error) {
      console.error('Erreur acceptation CGU:', error);
      setCguStatus(prev => ({
        ...prev,
        error: t('cgu.errors.acceptanceError')
      }));
      throw error;
    }
  };

  const declineCGU = async () => {
    try {
      const result = await cguService.declineCGU();
      return result;
    } catch (error) {
      console.error('Erreur refus CGU:', error);
      throw error;
    }
  };

  return {
    cguStatus,
    loadCGUStatus,
    acceptCGU,
    declineCGU,
    isAccepted: cguStatus.accepted,
    isLoading: cguStatus.loading,
    error: cguStatus.error
  };
};

export default useCGUStatus;
